import { Fragment } from "react";
import { useFetch } from "hooks/api";

import { Col, Row, Table } from "react-bootstrap";

const Snapshots = ({ adId }) => {
  const { data } = useFetch([Snapshots, adId], `/api/snapshots?ad_id=${adId}`, {
    default: [],
    enabled: true,
  });

  if (!data) {
    return null;
  }
  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12}>
            <span className="fs-4 fw-bold px-3">Ad Plan Snapshots</span>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Tgt Type</th>
                  <th>Premium Bid Adj</th>
                  <th>Bid Optm</th>
                  <th>Bid Mul</th>
                  <th>Bugt Type</th>
                  <th>Budget</th>
                  <th>Dlv Status</th>
                  <th>Start Date</th>
                  <th>State</th>
                  <th>Spending Plcy</th>
                  <th>Bid Strg</th>
                  <th>Bid Adjm</th>
                  <th>Amz Created</th>
                  <th>Amz Updated</th>
                  <th>Tactic</th>
                  <th>Cost Type</th>
                  <th>Delivery Prl</th>
                </tr>
              </thead>

              <tbody>
                {data?.data?.results.map((snapshot) => (
                  <Fragment key={snapshot.id}>
                    <tr>
                      <td colSpan={20}>
                        <span className="fw-bold">{snapshot.campaign_name}</span> - {snapshot.campaign_type}
                      </td>
                    </tr>
                    <tr>
                      <td>{snapshot.targeting_type}</td>
                      <td>{snapshot.premium_bid_adjustment}</td>
                      <td>{snapshot.bid_optimization}</td>
                      <td>{snapshot.bid_multipler}</td>
                      <td>{snapshot.budget_type}</td>
                      <td>{snapshot.budget}</td>
                      <td>{snapshot.delivery_status}</td>
                      <td>{snapshot.start_date}</td>
                      <td>{snapshot.state}</td>
                      <td>{snapshot.spending_policy}</td>
                      <td>{snapshot.bidding_strategy}</td>
                      <td>{snapshot.delivery_reasons}</td>
                      <td>{snapshot.amazon_created}</td>
                      <td>{snapshot.amazon_updated}</td>
                      <td>{snapshot.tactic}</td>
                      <td>{snapshot.cost_type}</td>
                      <td>{snapshot.delivery_profile}</td>
                    </tr>
                  </Fragment>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Snapshots;
